import { IEarlyAccess } from 'shared/types/earlyAccess';
import { ITypedReduxAction } from 'shared/types/redux';
import { actionGenerator } from 'shared/utils/redux';

export enum EEarlyAccessActionTypes {
  SetEarlyAccessData = 'EarlyAccess/SetEarlyAccessData',
}

type TEarlyAccessDataSetAction = ITypedReduxAction<EEarlyAccessActionTypes.SetEarlyAccessData, IEarlyAccess | null>;

export type TEarlyAccessDataActions = TEarlyAccessDataSetAction;

export const setEarlyAccessData = actionGenerator<EEarlyAccessActionTypes.SetEarlyAccessData, IEarlyAccess | null>(
  EEarlyAccessActionTypes.SetEarlyAccessData,
);
